export const type = {
    REGION: 'region',
    SUPER_REGION: 'super region',
};
